import React from 'react'
import { Field } from 'react-final-form'

import RadioField from '@cinch/oxd-components/field-inline-radio/src'
import Slider from '@cinch/oxd-components/filter-range/src'

import buildPriceOptions, { CASH_RANGE } from './build-price-options'

import * as styles from './fields.module.css'

export interface Props {
  i18n: Record<'cash' | 'partEx' | 'finance', string>
  hideAdditionalOptions?: boolean
  valueFormatter?: any
}

const CASH_VALUES = buildPriceOptions(CASH_RANGE)

const parseLogSlider = (values: number[]) => (index: number) => values[index]
const formatLogSlider = (values: number[]) => (value: number) => values.indexOf(value)

const financeOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
]

const Fields: React.FC<Props> = ({ i18n, hideAdditionalOptions, valueFormatter }) => (
  <>
    <div className={styles.formGroup}>
      <Field
        label={i18n.cash}
        name="budget"
        parse={parseLogSlider(CASH_VALUES)}
        format={formatLogSlider(CASH_VALUES)}
        component={Slider}
        valueFormatter={valueFormatter}
        min={0}
        max={CASH_VALUES.length - 1}
        step={1}
        hideValue={!hideAdditionalOptions}
      />
    </div>
    {!hideAdditionalOptions && (
      <>
        <Field name="partExchange" component={RadioField} options={financeOptions} label={i18n.partEx} />
        <Field name="finance" component={RadioField} options={financeOptions} label={i18n.finance} />
      </>
    )}
  </>
)

export default Fields
